import { CalculusTFunction } from '@retail/calculus/i18n';
import * as yup from 'yup';

const level = ['assortment', 'supplier', 'productGroup', 'discountGroup', 'item', ''] as const;
type Level = (typeof level)[number];
export type SelectableLevel = Exclude<Level, ''>;

export const assortmentLevels: SelectableLevel[] = ['assortment', 'productGroup'];
export const supplierLevels: SelectableLevel[] = [
  'supplier',
  'productGroup',
  'discountGroup',
  'item',
];

export const levelSelectSchema = (t: CalculusTFunction) => {
  return yup.object({
    level: yup
      .mixed<Level>()
      .oneOf(Object.values(level), t('calculus.error.chooseLevel'))
      .default('')
      .required(t('calculus.error.chooseLevel')),
    overGroup: yup
      .object()
      .default(null)
      .nullable()
      .when('level', {
        is: 'productGroup',
        then: yup.object().nullable().required(t('calculus.error.chooseOverGroup')),
      }),
    mainGroup: yup.object().default(null).nullable().when('level', {
      is: 'productGroup',
      then: yup.object().nullable().optional(),
    }),
    productGroup: yup.object().default(null).nullable().when('level', {
      is: 'productGroup',
      then: yup.object().nullable().optional(),
    }),
    discountGroups: yup
      .array()
      .of(yup.object().shape({ code: yup.string() }))
      .default([])
      .when('level', {
        is: 'discountGroup',
        then: yup
          .array()
          .of(yup.object().shape({ code: yup.string() }))
          .min(1, t('calculus.error.chooseDiscountGroup')),
      }),
    itemSearch: yup.string().default(''),
    item: yup
      .object()
      .default(null)
      .nullable()
      .when('level', {
        is: 'item',
        then: yup.object().nullable().required(t('calculus.error.chooseMgSupplierItem')),
      }),
  });
};

export type LevelSelectSchema = yup.InferType<ReturnType<typeof levelSelectSchema>>;
